// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2xy20","content":"LoadingAlert_content__3hrII"};